<template>
  <div class="full-width-login">
    <h1>Inloggen</h1>
    <br /><br />
    <v-form
      ref="form"
      v-model="valid"
      @submit.prevent="submitForm"
      lazy-validation
    >
      <v-text-field
        prepend-icon="person"
        label="E-mailadres"
        type="text"
        v-model="username"
        :rules="usernameRules"
        required
        validate-on-blur
      ></v-text-field>
      <v-text-field
        prepend-icon="lock"
        label="Wachtwoord"
        type="password"
        v-model="password"
        required
        :rules="[v => !!v || 'Wachtwoord is verplicht']"
        validate-on-blur
      ></v-text-field>
      <br /><br />
      <v-btn class="no-border-shadow no-margin btn-blue" type="submit">Inloggen</v-btn>
      <br><br>
      <a :href="resetURL"  class="lost-password" target="_blank">Wachtwoord vergeten?</a>
    </v-form>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  created() {
    if (this.loggedIn) {
      this.logout();
    }
  },
  data() {
    return {
      valid: true,
      username: "",
      password: "",
      usernameRules: [
        v => !!v || "E-mailadres is verplicht",
        v => /.+@.+/.test(v) || "Geen geldig e-mailadres"
      ]
    };
  },
  computed: {
    ...mapState("user", ["loggedIn"]),
      resetURL() {
          return process.env.VUE_APP_BACKEND_URL+'/user/reset-password-request';
      }
  },
  methods: {
    validate() {
      return this.$refs.form.validate();
    },
    submitForm() {
      if (this.validate()) {
        const { username, password } = this;
        this.login({ username, password })
          .then(() => {
            this.$store.dispatch("notification/add", {
              message: "Ingelogd als " + username
            });
            this.$router.push("/");
          })
          .catch(error => {});
      } else {
        let notification = {
          type: "error",
          message: "Kan niet inloggen met deze gegevens"
        };
        this.$store.dispatch("notification/add", notification);
      }
    },
    ...mapActions("user", ["login", "logout"])
  }
};
</script>

<style scoped></style>
